export default __webpack_public_path__ + "static/media/bg-sign-up-cover.30c5950b.jpeg";